import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { FormToolbar } from '../../common/FormToolbar';
import { AcademicContentFormFields } from './AcademicContentForm';

export const AcademicContentCreate = (props: any) => (
  <Create undoable={false} title="Upload Academic Content" {...props}>
    <SimpleForm className="main-form" toolbar={<FormToolbar {...props} />}>
      <AcademicContentFormFields />
    </SimpleForm>
  </Create>
);
